var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReimbursementLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4503"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.5 13.13V2.5C19.5 2.10218 19.342 1.72064 19.0607 1.43934C18.7794 1.15804 18.3978 1 18 1H6C5.60218 1 5.22064 1.15804 4.93934 1.43934C4.65804 1.72064 4.5 2.10218 4.5 2.5V13.13",
    stroke: "#1429B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.284 11.7151C21.3944 11.6275 21.5273 11.5728 21.6674 11.5573C21.8075 11.5418 21.9491 11.566 22.076 11.6273C22.203 11.6886 22.3101 11.7844 22.3851 11.9037C22.46 12.0231 22.4999 12.1611 22.5 12.3021V22.0021C22.5 22.3999 22.342 22.7814 22.0607 23.0627C21.7794 23.344 21.3978 23.5021 21 23.5021H3C2.60218 23.5021 2.22064 23.344 1.93934 23.0627C1.65804 22.7814 1.5 22.3999 1.5 22.0021V12.3021C1.50012 12.1611 1.53996 12.0231 1.61494 11.9037C1.68993 11.7844 1.79702 11.6886 1.92395 11.6273C2.05088 11.566 2.19251 11.5418 2.3326 11.5573C2.47268 11.5728 2.60556 11.6275 2.716 11.7151L10.147 17.6091C10.6755 18.0241 11.328 18.2498 12 18.2498C12.672 18.2498 13.3245 18.0241 13.853 17.6091L21.284 11.7151Z",
    stroke: "#1429B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.8086 16.0581L18.7506 19.0001",
    stroke: "#1429B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.192 16.0581L5.25 19.0001",
    stroke: "#1429B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12.2 10.3441C12.4166 10.6286 12.6985 10.8566 13.022 11.0089C13.3454 11.1612 13.7008 11.2333 14.058 11.2191C15.197 11.2191 16.121 10.5261 16.121 9.67212C16.121 8.81812 15.2 8.12612 14.062 8.12612C12.924 8.12612 12 7.43312 12 6.57812C12 5.72312 12.924 5.03112 14.062 5.03112C14.4193 5.01664 14.7747 5.08863 15.0982 5.24096C15.4217 5.3933 15.7036 5.62148 15.92 5.90612",
    stroke: "#1429B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M14.0625 11.2188V12.2498",
    stroke: "#1429B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M14.0625 4V5.031",
    stroke: "#1429B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M7.5 4.75H9",
    stroke: "#1429B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M7.5 7.75H9",
    stroke: "#1429B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M7.5 10.75H9",
    stroke: "#1429B8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReimbursementLogo);
export default __webpack_public_path__ + "static/media/reimbursement-logo.15413a101026626a3e7f26308105e76d.svg";
export { ForwardRef as ReactComponent };